import React from "react";
import LightWeightDashboards from "../pages/LightWeightCustomer/LightWeightDashboards";
import MvnoDashboards from "../pages/MVNO/MvnoDashboard";
import Dashboard from "../pages/Dashboard/Dashboard";
import InventoryDashboard from "../Components/InventoryDashboard/InventoryDashboard";

const DashboardWrapper = () => {
  const roleName = localStorage.getItem("roleName");

  if (roleName === "Customer") {
    return <LightWeightDashboards />;
  } else if (
    roleName === "telcoAdmin" ||
    roleName === "telcoOperationUser" ||
    roleName === "telcoBusinessUser"
  ) {
    return <MvnoDashboards />;
  } else if (
    roleName === "InventoryAdmin" ||
    roleName === "InventoryUser" ||
    roleName === "InventoryViewer" ||
    roleName === "InventoryPlusAdmin"
  ) {
    return <InventoryDashboard />;
  } else {
    return <Dashboard />;
  }
};

export default DashboardWrapper;
